import React from 'react';
import TablaUni from '../componentes/PopUps/TablaGUni';
import TablaTDA from '../componentes/PopUps/TablaTA';
import TablaGTV from '../componentes/PopUps/TablaGTV';
import TablaTAm from '../componentes/TablasGestionar/TablaTAm';
import TablaPB from '../componentes/PopUps/TablaPB';
import TablaDV from '../componentes/TablasGestionar/TablaDV';
import { Container, Paper, Typography } from '@mui/material';

export const Unidades = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Typography variant="h5" fontWeight="600" sx={{ color: '#001F3F', mb: 3 }}>
        Gestión de Unidades
      </Typography>
      <Paper sx={{ border: '1px solid #e0e0e0' }}>
        <TablaUni />
      </Paper>
    </Container>
  );
};

export const TipoDeActivos = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Typography variant="h5" fontWeight="600" sx={{ color: '#001F3F', mb: 3 }}>
        Gestión de Tipos de Activos
      </Typography>
      <Paper sx={{ border: '1px solid #e0e0e0' }}>
        <TablaTDA />
      </Paper>
    </Container>
  );
};

export const Probabilidades = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Typography variant="h5" fontWeight="600" sx={{ color: '#001F3F', mb: 3 }}>
        Gestión de Probabilidades
      </Typography>
      <Paper sx={{ border: '1px solid #e0e0e0' }}>
        <TablaPB />
      </Paper>
    </Container>
  );
};

export const TipoDeVulnerabilidades = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Typography variant="h5" fontWeight="600" sx={{ color: '#001F3F', mb: 3 }}>
        Gestión de Tipos de Vulnerabilidades
      </Typography>
      <Paper sx={{ border: '1px solid #e0e0e0' }}>
        <TablaGTV />
      </Paper>
    </Container>
  );
};

export const TipoDeAmenazas = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Typography variant="h5" fontWeight="600" sx={{ color: '#001F3F', mb: 3 }}>
        Gestión de Tipos de Amenazas
      </Typography>
      <Paper sx={{ border: '1px solid #e0e0e0' }}>
        <TablaTAm />
      </Paper>
    </Container>
  );
};

export const DimensionValoracion = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Typography variant="h5" fontWeight="600" sx={{ color: '#001F3F', mb: 3 }}>
        Gestión de Dimensiones de Valoración
      </Typography>
      <Paper sx={{ border: '1px solid #e0e0e0' }}>
        <TablaDV />
      </Paper>
    </Container>
  );
};
